// extracted by mini-css-extract-plugin
export var button = "_n0-0";
export var donut = "_n0-1";
export var donutFill = "_n0-3";
export var donutTrack = "_n0-2";